import './css/app.css';

import 'vendor/lazysizes';

import header from 'layout/header';
import { App } from '@grafikr/components';

import intersectionLoader from 'utils/loaders/intersection';
import onElementInteraction from 'utils/loaders/on-element-interaction';
import cartDrawer from 'components/cart-drawer';
import geoPopup from 'components/geo-popup';
import linkNavigation from 'layout/link-navigation';

const app = new App({
  // Layout
  header,
  'geo-popup': geoPopup,
  'cart-drawer': cartDrawer,

  // Components
  linked: [
    intersectionLoader,
    () => import(/* webpackChunkName: "component-linked" */ 'components/linked-products'),
  ],
  'lazy-content': [
    intersectionLoader,
    () => import(/* webpackChunkName: "component-lazy-content" */ 'components/lazy-content'),
  ],
  'product-slider': [
    intersectionLoader,
    () => import(/* webpackChunkName: "component-product-slider" */ 'components/product-slider'),
  ],
  'back-to-top': [
    intersectionLoader,
    () => import(/* webpackChunkName: "component-back-to-top" */ 'components/back-to-top'),
  ],
  'clerk-slider': [
    intersectionLoader,
    () => import(/* webpackChunkName: "component-clerk-slider" */ 'components/clerk-slider'),
  ],
  'announcement-bar': [
    intersectionLoader,
    () =>
      import(/* webpackChunkName: "component-announcement-bar" */ 'components/announcement-bar'),
  ],
  'mobile-menu': [
    onElementInteraction,
    () => import(/* webpackChunkName: "component-mobile-menu" */ 'components/mobile-menu'),
  ],
  accordion: [
    onElementInteraction,
    () => import(/* webpackChunkName: "component-accordion" */ 'components/accordion'),
  ],
  'live-search': [
    onElementInteraction,
    () => import(/* webpackChunkName: "component-live-search" */ 'components/search'),
  ],
  'cart-item': [
    intersectionLoader,
    () => import(/* webpackChunkName: "component-cart-item" */ 'components/cart-item'),
  ],
  'video-controls': [
    intersectionLoader,
    () => import(/* webpackChunkName: "video-controls" */ 'components/video-controls'),
  ],

  // Pages
  'collection-filter': [
    intersectionLoader,
    () => import(/* webpackChunkName: "collection-filter" */ 'pages/collection/filter'),
  ],
  product: [
    intersectionLoader,
    () => import(/* webpackChunkName: "product-main" */ 'pages/product/main'),
  ],
  'product-images': [
    intersectionLoader,
    () => import(/* webpackChunkName: "product-images" */ 'pages/product/product-images'),
  ],
  'product-recommendations': [
    intersectionLoader,
    () => import(/* webpackChunkName: "product-recommendations" */ 'pages/product/recommendations'),
  ],
  'log-in': [
    intersectionLoader,
    () => import(/* webpackChunkName: "log-in" */ 'pages/customers/log-in'),
  ],
  addresses: [
    intersectionLoader,
    () => import(/* webpackChunkName: "addresses" */ 'pages/customers/addresses'),
  ],
  blog: [intersectionLoader, () => import(/* webpackChunkName: "blog-page" */ 'pages/blog/main')],
  'search-page': [
    intersectionLoader,
    () => import(/* webpackChunkName: "search-page" */ 'pages/search/main'),
  ],
  wishlist: [
    intersectionLoader,
    () => import(/* webpackChunkName: "wishlist" */ 'pages/wishlist/main'),
  ],
});

app.mount();

document.addEventListener('app:remount', () => app.mount());

linkNavigation();
